var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.vehicles.length
    ? _c(
        "ul",
        { ref: "resultsBox", staticClass: "autocomplete-cars" },
        _vm._l(_vm.vehicles, function (v, key) {
          return _c(
            "li",
            {
              key: key,
              ref: "results",
              refInFor: true,
              class: { active: _vm.i == key },
              on: {
                mouseover: function ($event) {
                  _vm.i = key
                },
                click: function ($event) {
                  return _vm.setObject()
                },
              },
            },
            [_vm._v(_vm._s(v._plateNo))]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }